// extracted by mini-css-extract-plugin
export default {"errorText":"c14LRcgblJ6QWEvm_ozy","form":"Y6AN3Nn6j1SWAfHWXhgp"};